<div>
  <div class="hpanel" *ngIf="loadAPIcall">
    <app-common-skeleton [countforView]="5"
      [NameOftheScreen]="'candidateDetails'"></app-common-skeleton>
  </div>
  <!-- <div class="hpanel" *ngIf="!loadAPIcall">
    <div class="panel-heading hbuilt">
      <div class="section-header">
        <div class="header-title">
          About Candidate
        </div>
      </div>
      <div id="candidate_edit_resume_summary_button" *ngIf="CandidateData?.createdBy==userId">
        <button class="gs-icon-btn" title="Edit about candidate" (click)="modelResumeSummary(ResumeSummary)">
          <span>
            <ng-icon name="tablerPencil" class="gs-icon-action"></ng-icon>
          </span>
        </button>
      </div>
    </div>
    <div class="panel-body">
      <div class="row customRowGig">
        <div class="col-lg-12" style="word-break: break-all;"
          *ngIf="(CandidateData?.resumeSummary?.length!=0 && userType != 'JOB_SEEKER');else jobSeekerTemplate">
           <div [ngxSummernoteView]="CandidateData?.aboutCandidate" class="wrap-break" style="word-wrap: break-word;">
          </div>
          <div style="margin-left: -15px;" *ngIf="(CandidateData?.aboutCandidate === undefined || CandidateData?.aboutCandidate === '' ||
            CandidateData?.aboutCandidate === '<p><br></p>' || CandidateData?.aboutCandidate === '<br>')">
            <p class="about-candidate-message"> About candidate has not been provided </p>
          </div>
        </div>

        <ng-template #jobSeekerTemplate>
          <div *ngIf="(aboutMe === undefined || aboutMe === '' ||
                      aboutMe === '<p><br></p>' || aboutMe === '<br>')">
            <p class="about-candidate-message">
              {{ CandidateData?.createdBy === userId ? "You haven't added any details yet" : "About candidate has not
              been provided" }}
            </p>

          </div>
          <div class="col-lg-12" style="word-break: break-all;">
            <div *ngIf="userType === 'JOB_SEEKER'" [innerHtml]="aboutMe"></div>
          </div>
        </ng-template>



      </div>
    </div>
  </div> -->
 
  <div class="hpanel" *ngIf="!loadAPIcall">
    <div class="panel-heading hbuilt no-bt-br">
      <!-- Work Experience -->
      <!-- <div> -->
      <!-- <ng-icon name="tablerPlus" class="btn btn-xs btn-primary btn-circle icon-plus_data" *ngIf="CandidateData?.createdBy==userId" id="candidateWorkExperienceEdit"
        
        (click)="modelWorkExperience(WorkModel,'save')"></ng-icon> -->
      <!-- </div> -->
      <div class="section-header">
        <div class="header-title">
          Work Experience
        </div>
      </div>
      <div *ngIf="CandidateData?.createdBy==userId" id="candidateWorkExperienceEdit">
        <button class="gs-icon-btn" id="candidate_add_work_experience_button" title="Add work experience" (click)="modelWorkExperience(WorkModel,'save')">
          <span>
            <ng-icon name="tablerPlus" class="gs-icon-action"></ng-icon>
          </span>
        </button>
      </div>
    </div>
    <div class="panel-body">
      <div *ngIf="CandidateData?.workExperiences?.length > 0; else noExperienceTemplate">
        <div class=" row" *ngFor="let work of  CandidateData?.workExperiences; let i = index; let lastItem= last">
          <div class="col-sm-2" *ngIf="work.organisationName!=undefined&&work.organisationName!=null&&
                    work.organisationName!=''">
            <img class="img" height="73px" width="73px" style="margin-left: -16px;"
              src="assets/images/gallery/company.png">
          </div>
          <div class="col-sm-8" *ngIf="work.organisationName!=undefined&&work.organisationName!=null&&
                    work.organisationName!=''">
            <!-- <div class="letter-gaps project-label ellipsis">
              {{work.organisationName}}
            </div> -->
            <div class="wrap"
              [ngClass]="hasSpace(work?.organisationName) ? 'wrap-normal' : 'wrap-ellipsis'">
              {{work.organisationName}}
            </div>
            <div *ngIf="work.title!=undefined&&work.title!=null&&
                            work.title!=''" class="letter-gaps">
              {{work.title}}
            </div>
            <div *ngIf="work.city!=undefined&&work.city!=null&&
                                        work.city!=''&&
                                        work.state!=undefined&&work.state!=null&&
                                        work.state!=''&&
                                        work.country!=undefined&&work.country!=null&&
                                        work.country!=''" class="letter-gaps" style="margin-bottom: -6px;">
              <!-- {{", Zip - "}}{{work.zipcode}} -->
              <!-- {{work.street}}{{", "}} -->
              {{work.city}}{{", "}}{{work.state}}{{", "}}<span style="display: inline-block;"
                *ngFor="let country of countryList">
                <p *ngIf="country.countryCode == work.country">{{country.countryName}}</p>
              </span>
            </div>
            <!-- currentIndex!=i&& -->
            <div class="letter-gaps" *ngIf="work.currentOrganization==false&&
                        work.startMonth!=undefined&&work.startMonth!=null&&work.startMonth!=''&&
                        work.startYear!=undefined&&work.startYear!=null&&work.startYear!=''&&
                        work.endMonth!=undefined&&work.endMonth!=null&&work.endMonth!=''&&
                        work.endYear!=undefined&&work.endYear!=null&&work.endYear!=''">
              {{work.startMonth.substring(0, 3)}}{{", "}}{{work.startYear }}
              {{" - "}}{{work.endMonth.substring(0, 3)}}{{", "}}{{work.endYear }}
            </div>
            <!-- currentIndex==i&& -->
            <div class="letter-gaps" *ngIf="work.currentOrganization==true&&
                        work.startMonth!=undefined&&work.startMonth!=null&&work.startMonth!=''&&
                        work.startYear!=undefined&&work.startYear!=null&&work.startYear!=''">
              {{work.startMonth.substring(0, 3)}}{{", "}}{{work.startYear}}{{" - "}}
              <span class="label label-info font-normal" style="font-size: 11px;">Present</span>
            </div>
            <hr *ngIf="!lastItem">
          </div>
          <div class="col-sm-1">
            <!-- <div class="btn-group" style="margin-left: -13px;" title="Edit work experience"
                  (click)="workexpEdit(WorkModel, work, 'edit')">
                  <button class="edit-pencil"><span  >
                      <ng-icon name="tablerPencil" *ngIf="CandidateData?.createdBy==userId" style="cursor: pointer; color: #8B5CF6 !important;font-size: 15px;"></ng-icon>
                    </span></button>
                </div> -->
            <div id="candidate_edit_work_experience_button" *ngIf="CandidateData?.createdBy==userId">
              <button class="gs-icon-btn" title="Edit work experience" (click)="workexpEdit(WorkModel, work, 'edit')">
                <span>
                  <ng-icon name="tablerPencil" class="gs-icon-action"></ng-icon>
                </span>
              </button>
            </div>
          </div>
          <div class="col-sm-1">
            <div id="candidate_remove_work_experience_button" *ngIf="CandidateData?.createdBy==userId">
              <button class="gs-icon-btn" title="Remove work experience" (click)="removeWorkExperience(work)">
                <span>
                  <ng-icon name="tablerTrash" class="gs-icon-action"></ng-icon>
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <ng-template #noExperienceTemplate>
        There is no work experience provided yet for the candidate.
      </ng-template>
    </div>
  </div>
  <div class="hpanel" *ngIf="!loadAPIcall">
    <div class="panel-heading hbuilt no-bt-br">
      <!-- Education Details
        <ng-icon name="tablerPlus" class="btn btn-xs btn-primary btn-circle icon-plus_data" *ngIf="userId==CandidateData?.createdBy" id="candidateEducationDetails"
          
          (click)="modelEducation(EducationModule,'save')"></ng-icon> -->
      <div class="section-header">
        <div class="header-title">
          Education Details
        </div>
      </div>
      <div *ngIf="CandidateData?.createdBy==userId" id="candidateEducationDetails">
        <button class="gs-icon-btn" id="candidate_add_education_button" title="Add education" (click)="modelEducation(EducationModule,'save')">
          <span>
            <ng-icon name="tablerPlus" class="gs-icon-action"></ng-icon>
          </span>
        </button>
      </div>
    </div>
    <div class="panel-body">
      <!-- <p *ngIf="CandidateData?.educationDetails?.length == 0">You haven't added any education details yet</p> -->
      <div *ngIf="CandidateData?.educationDetails?.length > 0; else noEducationTemplate">
        <div *ngFor="let edu of CandidateData?.educationDetails; let i=index; let lastItem = last">
          <div *ngIf="edu.schoolName!=undefined&&edu.schoolName!=null&&edu.schoolName!=''">
            <div class="row" style="margin-bottom: 10px;">
              <div class="col-sm-2">
                <img class="img" style="margin-left: -13px;height: 73px;width: 73px;"
                  src="assets/images/gallery/education.png">
              </div>
              <div class="col-sm-8">
                <div class="project-label letter-gaps">
                  {{edu.schoolName}}
                </div>
                <div class="letter-gaps" *ngIf="edu.degree!=undefined&&edu.degree!=null&&edu.degree!=''">
                  {{edu.degree}}
                </div>
                <div class="letter-gaps" *ngIf="edu.city!=undefined&&edu.city!=null&&edu.city!=''&&
                                                  edu.state!=undefined&&edu.state!=null&&edu.state!=''&&
                                                  edu.country!=undefined&&edu.country!=null&&edu.country!=''&&
                                                  edu.street!=undefined&&edu.street!=null&&edu.street!=''&&
                                                  edu.zipcode!=undefined&&edu.zipcode!=null&&edu.zipcode!=''"
                  style="margin-bottom: -6px;">
                  {{edu.street}}{{", "}} {{edu.city}}{{", "}}{{edu.state}}{{", "}}<span style="display: inline-block;"
                    *ngFor="let country of countryList">
                    <p *ngIf="country.countryCode == edu.country">{{country.countryName}}</p>
                  </span>
                </div>
                <!-- {{", Zip - "}}{{edu.zipcode}} -->
                <div class="letter-gaps" *ngIf="edu.startMonth!=undefined&&edu.startMonth!=null&&edu.startMonth!=''&&
                          edu.startYear!=undefined&&edu.startYear!=null&&edu.startYear!=''&&
                          edu.endMonth!=undefined&&edu.endMonth!=null&&edu.endMonth!=''&&
                          edu.endYear!=undefined&&edu.endYear!=null&&edu.endYear!='' &&
                          edu.currentlyPursued!=true">
                  {{edu.startMonth.substring(0, 3)}}{{", "}}{{edu.startYear}}{{" - "}}
                  {{edu.endMonth.substring(0, 3)}}{{", "}}{{edu.endYear}}
                </div>
                <div class="letter-gaps" *ngIf=" edu.currentlyPursued==true">
                  {{edu.startMonth.substring(0, 3)}}{{", "}}{{edu.startYear}} {{" - "}}
                  <span class="label label-info font-normal" style="font-size: 11px;">Present</span>
                </div>
              </div>
              <div class="col-sm-1" style="text-align-last: end;">
                <!-- <div class="btn-group" style="margin-left: -13px;" title="Edit education"
                    (click)="eduEdit(EducationModule, edu, 'edit')">
                    <button class="edit-pencil"><span>
                        <ng-icon name="tablerPencil" style="cursor: pointer; color: #8B5CF6 !important;font-size: 15px;"></ng-icon>
                      </span></button>
                  </div> -->
                <div id="candidate_edit_education_button" *ngIf="CandidateData?.createdBy==userId">
                  <button class="gs-icon-btn" title="Edit education" (click)="eduEdit(EducationModule, edu, 'edit')">
                    <span>
                      <ng-icon name="tablerPencil" class="gs-icon-action"></ng-icon>
                    </span>
                  </button>
                </div>
              </div>
              <div class="col-sm-1">
                <!-- *ngIf="(commonVariables?.localUser&&infoData.educationDetail.length>1&&commonVariables?.studentFlag)||
                                  (commonVariables?.localUser&&!commonVariables?.studentFlag)" -->
                <!-- <div class="btn-group" style="margin-left: -13px;" title="Remove education"
                    (click)="removeEducation(edu)">
                    <button class="edit-pencil"><span>
                        <ng-icon name="tablerTrash" style="cursor: pointer; color: #8B5CF6 !important;font-size: 15px;"></ng-icon>
                      </span></button>
                  </div> -->
                <div id="candidate_remove_education_button" *ngIf="CandidateData?.createdBy==userId">
                  <button class="gs-icon-btn" title="Remove education" (click)="removeEducation(edu)">
                    <span>
                      <ng-icon name="tablerTrash" class="gs-icon-action"></ng-icon>
                    </span>
                  </button>
                </div>
              </div>
            </div>
            <hr *ngIf="!lastItem" style="margin-top: 0px;">
          </div>
        </div>
      </div>
      <ng-template #noEducationTemplate>
        <div>There is no education provided yet for the candidate.</div>
      </ng-template>
    </div>
  </div>
  <div class="hpanel" *ngIf="!loadAPIcall">
    <div class="panel-heading hbuilt no-bt-br">
      <!-- <div  > -->
      <!-- Certification
        <ng-icon name="tablerPlus" class="btn btn-xs btn-primary btn-circle icon-plus_data" *ngIf="userId==CandidateData?.createdBy" id="CandidatecertificationDetails"
          
          (click)="modelCertification(certificationModel,'save')"></ng-icon> -->
      <div class="section-header">
        <div class="header-title">
          Certification
        </div>
      </div>
      <div *ngIf="CandidateData?.createdBy==userId" id="CandidatecertificationDetails">
        <button class="gs-icon-btn" title="Add certification" (click)="modelCertification(certificationModel,'save')">
          <span>
            <ng-icon name="tablerPlus" class="gs-icon-action"></ng-icon>
          </span>
        </button>
      </div>
    </div>
    <!-- </div> -->
    <div class="panel-body">
      <!-- <p *ngIf="CandidateData?.candidateCertifications?.length == 0">Certification details of the candidate has not been
        provided.</p> -->
      <div *ngIf="CandidateData?.candidateCertifications?.length > 0; else noCertificationTemplate">
        <div class="row"
          *ngFor="let cert of CandidateData?.candidateCertifications; let i = index; let lastItem = last">
          <div class="col-sm-10">
            <div class="letter-gaps">
              {{cert.certificationName}}
            </div>
            <div class="letter-gaps" *ngIf="cert.certificateOrganization!=null && cert.certificateOrganization!=undefined&&
                                cert.certificateOrganization!=''">
              {{cert.certificateOrganization}}
            </div>
            <div class="letter-gaps" *ngIf="cert.startMonth!=null && cert.startMonth!=undefined&&cert.startMonth!=''&&
                                    cert.startYear!=null && cert.startYear!=undefined&&cert.startYear!=''&&
                                    cert.endMonth!=null && cert.endMonth!=undefined&&cert.endMonth!=''&&
                                    cert.endYear!=null && cert.endYear!=undefined&&cert.endYear!=''">
              {{cert.startMonth.substring(0, 3) + ", "}}{{cert.startYear}}
              {{" - "}}{{cert.endMonth.substring(0, 3) + ", "}}{{cert.endYear}}
            </div>
            <hr *ngIf="!lastItem">
          </div>
          <div class="col-sm-1" style="text-align-last: end;">
            <!-- <div class="btn-group" style="margin-left: -13px;" title="Edit certification"
                (click)="certEdit(certificationModel, cert, 'edit')">
                <button class="edit-pencil"><span>
                    <ng-icon name="tablerPencil" style="cursor: pointer; color: #8B5CF6 !important;font-size: 15px;"></ng-icon>
                  </span></button>
              </div> -->
            <div *ngIf="CandidateData?.createdBy==userId">
              <button class="gs-icon-btn" title="Edit certification" (click)="certEdit(certificationModel, cert, 'edit')">
                <span>
                  <ng-icon name="tablerPencil" class="gs-icon-action"></ng-icon>
                </span>
              </button>
            </div>
          </div>
          <div class="col-sm-1">
            <!-- <div class="btn-group" style="margin-left: -13px;" title="Remove certification"
                (click)="removeCertification(cert)">
                <button class="edit-pencil"><span>
                    <ng-icon name="tablerTrash" style="cursor: pointer; color: #8B5CF6 !important;font-size: 15px;"></ng-icon>
                  </span></button>
              </div> -->
            <div *ngIf="CandidateData?.createdBy==userId">
              <button class="gs-icon-btn" title="Remove certification" (click)="removeCertification(cert)">
                <span>
                  <ng-icon name="tablerTrash" class="gs-icon-action"></ng-icon>
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <ng-template #noCertificationTemplate>
        There are no certifications provided yet for the candidate.
      </ng-template>
    </div>
  </div>
</div>
<ng-template #ResumeSummary>
  <div class="modal-header">
    <h4 class="modal-title pull-left "> About Candidate </h4>
    <span class="modalai-close" aria-hidden="true" (click)="closeModal()">&times;</span>
  </div>
  <div class="modal-body R-summary">
    <ng-container>
      <form [formGroup]="CadidateInfo" class="form-horizontal padding15">
        <div formControlName="resumeSummary"  [ngxSummernote]="config2">
        </div>
        <div class="text-danger" *ngIf="amsubmit&&!CadidateInfo.controls.resumeSummary.errors?.minchar"> About Candidate is required</div>
        <div *ngIf="
                CadidateInfo.controls.resumeSummary.invalid &&  (CadidateInfo.controls.resumeSummary.dirty || CadidateInfo.controls.resumeSummary.touched)" class="red fl">

          <div *ngIf="CadidateInfo.controls.resumeSummary.errors.maxchar">
            {{FORMERROR.ABOUT_YOUR_MAX}}
          </div>
        </div>
        <div class="text-right" *ngIf="!CadidateInfo.controls.resumeSummary.errors?.maxchar">
          <label>
            <small>
              <span>{{ remainingCharacters }}</span>
              Characters remaining
            </small>
          </label>
        </div>
      </form>
    </ng-container>
  </div>
  <div class="modal-footer">
    <div class="col-md-12 padding15 text-right" style="padding:3px 0; ">
      <button class="btn btn-default w70" (click)="closeModal()">Cancel</button>
      <button class="btn btn-primary txt-al-ce  w70"
        style="border: 1px solid #8B5CF6; color:#fff; background-color: #8B5CF6;" (click)="saveaboutUS()"> Submit
      </button>
    </div>
  </div>
</ng-template>
<ng-template #WorkModel>
  <div class="modal-header">
    <h4 class="pull-left modal-title"> Work Experience </h4>
    <span class="modalai-close" aria-hidden="true" (click)="close()">&times;</span>
  </div>
  <div class="modal-body ">
    <ng-container>
      <form [formGroup]="CadidateWorkExpeiecnceForm" class="form-horizontal padding15">
        <div class="row form-group">
          <label for="organisationName" class="col-sm-3 control-label required-field text-right font-light">
            Organization </label>
          <!-- <div class="col-sm-8">
            <input placeholder="Organisation Name" class="form-control input-sm max-hight" #mytext matInput
              [matAutocomplete]="auto" debounceTime="1000" formControlName="organisationName" trim="blur"
              (keyup)="manageOrgList($event.target.value)" maxlength="101" />
            <div *ngIf="(workFromControl.organisationName.dirty || workFromControl.organisationName.touched) && workFromControl.organisationName.errors" class="error-msg">
              <div class="error-msg" *ngIf="workFromControl.organisationName.errors?.required">
                Organization Name is required
              </div>
              <div class="error-msg" *ngIf="workFromControl.organisationName.errors?.minword">
                {{FORMERROR.ORGANIZATION_NAME_MIN}}
              </div>
              <div class="error-msg" *ngIf="workFromControl.organisationName.errors?.maxword">
                {{FORMERROR.ORGANIZATION_NAME_MAX}}
              </div>
            </div>
            <div>
              <ng-container>
                <mat-autocomplete #auto="matAutocomplete">
                  <mat-optgroup *ngIf="searchBarShow && organizationList?.length > 0"
                    style="position: relative; top: -43px;">
                    <mat-option *ngFor="let option of organizationList | slice: 0:20" [value]="option.organizationName"
                      (click)="onChangeorg(option)">
                      <div style="display: grid;
                        row-gap: 0px;
                        line-height: initial;">
                        <div style="display:none" id="mat-optgroup-label-1"></div>
                        <div>
                          <strong style="font-size: 13px; padding: 0px 6px 0px 0px;" class="ellipse">
                            {{option.organizationName}}
                          </strong>
                        </div>
                        <div style="line-height: 10px;">
                          <i>
                            <div style="font-size: 60%;">
                              {{option.address1 }}<span *ngIf="option.address1 && option.address2">{{", "}}</span>
                              {{option.address2}}
                            </div>
                          </i>
                        </div>
                        <div style="line-height: 10px;">
                          <i>
                            <div style="font-size: 60%;">
                              {{option.street }}<span *ngIf="option.street">{{", "}}</span>
                              {{option.city}}<span *ngIf="option.city">{{", "}}</span>
                              {{option.state}}<span *ngIf="option.state">{{", "}}</span>
                              {{option.countryName}}
                            </div>
                          </i>
                        </div>
                      </div>
                    </mat-option>
                  </mat-optgroup>
                </mat-autocomplete>
              </ng-container>
            </div>
          </div> -->
          <div class="col-sm-8">
            <!-- Plain-input typeahead, same as the Personal Profile work-experience
                 modal (workexperience-modal.component.html). A text control keeps the
                 typed value on its own — no ng-select filter/label juggling — so a
                 free-text organisation survives an outside click without help. -->
            <div class="autocomplete-container">
              <input type="text" placeholder="Organisation Name" class="form-control input-sm"
                formControlName="organisationName" maxlength="101"
                [ngClass]="{ 'is-invalid': (workFromControl.organisationName.dirty || workFromControl.organisationName.touched) && workFromControl.organisationName.invalid }"
                (focus)="showOrgListAgain()" (input)="manageOrgList($event.target.value)" />

              <div *ngIf="searchBarShow && organizationList?.length > 0" class="suggestion-list" infiniteScroll
                [infiniteScrollDistance]="2" [infiniteScrollThrottle]="800" [scrollWindow]="false"
                (scrolled)="onScrollDown()">
                <ul>
                  <li *ngFor="let option of organizationList; trackBy: uniqueOrgTrack" (click)="onChangeorg(option)">
                    <div class="workExp">
                      <strong class="ellipse orgName">{{ option.organizationName }}</strong>
                      <div class="address">
                        <i>
                          <div class="address-font">
                            {{ option.address1 }}<span *ngIf="option.address1 && option.address2">, </span>{{ option.address2 }}
                          </div>
                        </i>
                      </div>
                      <div class="location">
                        <i>
                          <div class="location-details">
                            {{ option.street }}<span *ngIf="option.street">, </span>{{ option.city }}<span *ngIf="option.city">, </span>{{ option.state }}<span *ngIf="option.state">, </span>{{ option.countryName }}
                          </div>
                        </i>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div *ngIf="(workFromControl.organisationName.dirty || workFromControl.organisationName.touched) && workFromControl.organisationName.invalid ">
              <div class="" *ngIf="workFromControl.organisationName.errors?.required"
                style="font-size:12px; font-weight:500; color:red;float:right;">
                Organization Name is required
              </div>
              <div class="" *ngIf="workFromControl.organisationName.errors?.minword"
                style="font-size:12px; font-weight:500; color:red;float:right;">
                {{FORMERROR.ORGANIZATION_NAME_MIN}}
              </div>
              <div class="" *ngIf="workFromControl.organisationName.errors?.maxword"
                style="font-size:12px; font-weight:500; color:red;float:right;">
                {{FORMERROR.ORGANIZATION_NAME_MAX}}
              </div>
            </div>
          </div>
        </div>
        <div class="custom-checkbox" title="Check if this is your current workplace">
          <label class="checkbox-label font-bold" style="margin-left: 151px; margin-top: -29px;">Current
            Organization
            <input type="checkbox" (change)="curOrg($event)" formControlName="currentOrganization"
              name="currentOrganization">
            <span class="checkmark"></span>
          </label>
        </div>
        <div class="form-group row">
          <label for="title" class="col-sm-3 control-label required-field text-right font-light">Organization
            Type</label>
          <div class="col-sm-8">
            <ng-select class="gs-pill-select" formControlName="clientType" placeholder="Organization Type"
              [clearable]="false" dropdownPosition="auto"
              [ngClass]="{ 'is-invalid': submittedWorkexp && workFromControl.clientType.errors }">
              <ng-option *ngFor="let clientType of clientTypeList" [value]="clientType">{{clientType}}</ng-option>
            </ng-select>
            <div *ngIf="submittedWorkexp && workFromControl.clientType.errors" class="error-msg">
              <div class="error-msg" *ngIf="workFromControl.clientType.errors?.required"> Organization Type is required
              </div>
            </div>
          </div>
        </div>
        <div class="row form-group">
          <label for="title" class="col-sm-3 control-label required-field text-right font-light">Title</label>
          <div class="col-sm-8">
            <div>
              <ng-select class="gs-clear-plain"
                [ngClass]="{ 'is-invalid': submittedWorkexp && workFromControl.title.errors }"
                [items]="candidateJobTitleList" [addTag]="true" [hideSelected]="true" dropdownPosition="bottom"
                [clearable]="true" formControlName="title" [multiple]="false" placeholder="Title">
              </ng-select>
            </div>
            <div *ngIf="submittedWorkexp && workFromControl.title.errors" class="error-msg">
              <div class="error-msg" *ngIf="workFromControl.title.errors?.required"> Title is required</div>
            </div>
          </div>
        </div>
        <div class="row form-group">
          <label class="control-label col-sm-3 required-field text-right font-light">Location</label>
          <div class="col-sm-8">
            <div class="row form-group">
              <div class="col-sm-6">
                <!-- Placeholder must be [ngValue]="null" — the control's real
                     null never equals the string "null", which rendered a
                     blank phantom option instead (same fix as Education
                     below). Real options stay [value] because (change) reads
                     $event.target.value. -->
                <select class="form-control input-sm"
                  [ngClass]="{ 'is-invalid': submittedWorkexp && workFromControl.country.errors }"
                  formControlName="country" type="text" (change)="onChangeCountry($event.target.value,'work')">
                  <option [ngValue]="null" disabled>Country</option>
                  <option *ngFor="let country of countryList" [value]="country.countryCode">
                    {{country.countryName}}</option>
                </select>
                <div *ngIf="submittedWorkexp && workFromControl.country.errors" class="error-msg">
                  <div class="error-msg" *ngIf="workFromControl.country.errors?.required"> Country is required</div>
                </div>
              </div>
              <div class="col-sm-6">
                <!-- Mirrors the fixed Education state select: [ngValue]="null"
                     placeholder (real null match) + [ngValue] options. -->
                <select *ngIf="stateList.length!=0" class="form-control input-sm"
                  [ngClass]="{ 'is-invalid': submittedWorkexp && workFromControl.state.errors }" formControlName="state"
                  id="ca" type="text">
                  <option [ngValue]="null" disabled>State</option>
                  <option *ngFor="let state of stateList" [ngValue]="state.stateName">
                    {{state.stateName}}</option>
                </select>
                <input *ngIf="stateList.length==0" type="text" placeholder="State"
                  [ngClass]="{ 'is-invalid': submittedWorkexp && workFromControl.state.errors }" formControlName="state"
                  class="form-control input-sm">
                <div *ngIf="submittedWorkexp && workFromControl.state.errors" class="error-msg">
                  <div class="error-msg" *ngIf="workFromControl.state.errors?.required"> State is required</div>
                </div>
              </div>
            </div>
            <div class="row ">
              <div class="col-sm-6">
                <input type="text" placeholder="City"
                  [ngClass]="{ 'is-invalid': submittedWorkexp && workFromControl.city.errors }" formControlName="city"
                  class="form-control input-sm">
                <div *ngIf="submittedWorkexp && workFromControl.city.errors" class="error-msg">
                  <div class="error-msg" *ngIf="workFromControl.city.errors?.required"> City is required</div>
                </div>
              </div>
              <div class="col-sm-6">
                <input type="text" maxlength="12" placeholder="Zipcode"
                  [ngClass]="{ 'is-invalid': submittedWorkexp && workFromControl.zipcode.errors }"
                  formControlName="zipcode" class="form-control input-sm">
                <div *ngIf="submittedWorkexp && workFromControl.zipcode.errors" class="error-msg">
                  <div class="error-msg" *ngIf="workFromControl.zipcode.errors?.required">
                    Zipcode is required
                  </div>
                  <div class="error-msg" *ngIf="workFromControl.zipcode.errors?.minword">
                    {{FORMERROR.ZIPCODE_MIN}}
                  </div>
                  <div class="error-msg" *ngIf="workFromControl.zipcode.errors?.maxword">
                    {{FORMERROR.ZIPCODE_MAX}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-3 control-label  required-field text-right font-light">From Date</label>
          <div class="col-sm-8">
            <div class="row">
              <div class="col-sm-6">
                <ng-select class="gs-pill-select" formControlName="startMonth" placeholder="Month"
                  [clearable]="false" dropdownPosition="auto"
                  [ngClass]="{ 'is-invalid': submittedWorkexp && workFromControl.startMonth.errors }"
                  (change)="monthChange('exp')">
                  <ng-option *ngFor="let month of months" [value]="month.name"
                    [disabled]="checkMonth1(month.code,'exp')">{{month.name}}</ng-option>
                </ng-select>
                <div *ngIf="submittedWorkexp && workFromControl.startMonth.errors" class="error-msg">
                  <div *ngIf="workFromControl.startMonth.errors?.required">
                    Month is required </div>
                </div>
              </div>
              <div class="col-sm-6">
                <ng-select class="gs-pill-select" formControlName="startYear" placeholder="Year"
                  [clearable]="false" dropdownPosition="auto"
                  [ngClass]="{ 'is-invalid': submittedWorkexp && workFromControl.startYear.errors }"
                  (change)="expStartYearChange()">
                  <ng-option *ngFor="let year of years" [value]="year">{{year}}</ng-option>
                </ng-select>
                <div *ngIf="submittedWorkexp && workFromControl.startYear.errors" class="error-msg">
                  <div *ngIf="workFromControl.startYear.errors?.required">
                    Start Year is required</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group row" *ngIf="CadidateWorkExpeiecnceForm.value.currentOrganization!=true">
          <label class="col-sm-3 control-label  required-field text-right font-light">To Date
          </label>
          <div class="col-sm-8">
            <div class="row">
              <div class="col-sm-6">
                <ng-select class="gs-pill-select" formControlName="endMonth" placeholder="Month"
                  [clearable]="false" dropdownPosition="auto"
                  [ngClass]="{ 'is-invalid': submittedWorkexp && workFromControl.endMonth.errors }">
                  <ng-option *ngFor="let month of months" [value]="month.name"
                    [disabled]="checkMonth(month.code,'exp')">{{month.name}}</ng-option>
                </ng-select>
                <div *ngIf="submittedWorkexp && workFromControl.endMonth.errors" class="error-msg">
                  <div *ngIf="workFromControl.endMonth.errors?.required">
                    Month is required</div>
                </div>
              </div>
              <div class="col-sm-6">
                <ng-select class="gs-pill-select" formControlName="endYear" placeholder="Year"
                  [clearable]="false" dropdownPosition="auto"
                  [ngClass]="{ 'is-invalid': submittedWorkexp && workFromControl.endYear.errors }"
                  (change)="onChangeYear('exp')">
                  <ng-option *ngFor="let year of years" [value]="year"
                    [disabled]="checkYear(year,'exp')">{{year}}</ng-option>
                </ng-select>
                <div *ngIf="submittedWorkexp && workFromControl.endYear.errors" class="error-msg">
                  <div *ngIf="workFromControl.endYear.errors?.required">
                    End Year is required</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </ng-container>
  </div>
  <div class="modal-footer">
    <div class="col-md-12 text-right" style="padding: 3px 0;">
      <button class="btn btn-default" (click)="close()">Cancel</button>
      <button class="btn  btn-primary btn-danger2  txt-al-ce"
        style="border: 1px solid #8B5CF6; color:#fff;background-color: #8B5CF6;" (click)="workExperSave()"> Submit
      </button>
    </div>
  </div>
</ng-template>
<ng-template #EducationModule>
  <div class="modal-header">
    <h4 class="pull-left modal-title"> Education Details </h4>
    <span class="modalai-close" aria-hidden="true" (click)="modalRef.hide()">&times;</span>
  </div>
  <div class="modal-body ">
    <ng-container>
      <form [formGroup]="CadidateEducationForm" class="form-horizontal padding15">
        <div class="row">
          <div class="form-group">
            <label for="schoolName" class="col-sm-4 control-label required-field font-light">School / College /
              University</label>
            <div class="col-sm-7">
              <div class="row">
                <div class="col-sm-12">
                  <!-- Plain typeahead input — same control the profile page uses. ng-select
                       rendered the chosen school as a purple chip with a × and wouldn't let
                       the name be edited in place. A real <input> shows it as normal text
                       ("Nitsha"), stays editable, and free-text (a brand-new college) works
                       natively. Suggestions come from the SAME per-keystroke server search
                       as before (care/intitutions/<term>) via [typeaheadAsync] — the full
                       institution master is never loaded, which is what froze the page. -->
                  <input placeholder="School Name" maxlength="51" class="form-control input-sm max-hight"
                    formControlName="schoolName" autocomplete="off"
                    [ngClass]="{ 'is-invalid': submittedEducation && educationFormControl.schoolName.errors }"
                    [typeahead]="schoolSuggestions$" [typeaheadAsync]="true" [typeaheadMinLength]="1"
                    typeaheadOptionField="institutionName"
                    [typeaheadItemTemplate]="customSchoolItemTemplate"
                    (typeaheadOnSelect)="onChangeSchool($event)"
                    (typeaheadNoResults)="changeTypeaheadNoResults($event)"
                    (input)="onSchoolNameChanged()">
                  <ng-template #customSchoolItemTemplate let-model="item">
                    <div class="workExp">
                      <strong class="ellipse orgName">{{ model.institutionName }}</strong>
                      <div class="address">
                        <i>
                          <div class="address-font">
                            {{ model.address1 }}<span *ngIf="model.address1 && model.address2">, </span>{{ model.address2 }}
                          </div>
                        </i>
                      </div>
                      <div class="location">
                        <i>
                          <div class="location-details">
                            {{ model.street }}<span *ngIf="model.street">, </span>{{ model.city }}<span *ngIf="model.city">, </span>{{ model.state }}<span *ngIf="model.state">, </span>{{ model.countryName }}
                          </div>
                        </i>
                      </div>
                    </div>
                  </ng-template>
                  <div *ngIf="submittedEducation && educationFormControl.schoolName.errors" class="error-msg">
                    <div class="error-msg" *ngIf="educationFormControl.schoolName.errors.required">
                      School Name is required
                    </div>
                    <div class="error-msg" *ngIf="educationFormControl.schoolName.errors.minword">
                      {{FORMERROR.SCHOOL_NAME_MIN}}
                    </div>
                    <div class="error-msg" *ngIf="educationFormControl.schoolName.errors.maxword">
                      {{FORMERROR.SCHOOL_NAME_MAX}}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <div class="custom-checkbox" title="Check if this is your current education">
                    <label class="checkbox-label font-bold" style="text-align: center">Currently Pursuing
                      <input type="checkbox" formControlName="currentlyPursued" (click)="changeEduOrg($event)"
                        name="currentlyPursued">
                      <div *ngIf="educationFormControl.currentlyPursued.errors">
                        <div *ngIf="educationFormControl.currentlyPursued.errors.required" style="color: #c3002f;">
                          currentlyPursued is required
                        </div>
                      </div>
                      <span class="checkmark" title="Check this if you're currently studying here"></span>
                    </label>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="custom-checkbox">
                    <label class="checkbox-label font-bold"> Show this education in Profile
                      <input type="checkbox" formControlName="showThisOnProfile" name="showThisOnProfile">
                      <span class="checkmark"
                        title="Only when this is checked, this workplace is shown in Profile"></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <label class="control-label required-field col-sm-4 font-light">Location</label>
          <div class="col-sm-7" style="margin-bottom: 10px;">
            <div class="row form-group">
              <div class="col-sm-6">
                <select class="form-control input-sm"
                  [ngClass]="{ 'is-invalid': submittedEducation && educationFormControl.country.errors }"
                  formControlName="country" type="text" (change)="onChangeCountry($event.target.value,'edu')">
                  <option [ngValue]="null" disabled>Country</option>
                  <option *ngFor="let country of countryList" [value]="country.countryCode">
                    {{country.countryName}}</option>
                </select>
                <div *ngIf="submittedEducation && educationFormControl.country.errors" class="error-msg">
                  <div class="error-msg" *ngIf="educationFormControl.country.errors.required"> Country is required
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <select *ngIf="stateList.length!=0" class="form-control input-sm"
                  [ngClass]="{ 'is-invalid': submittedEducation && educationFormControl.state.errors }"
                  formControlName="state" id="ca" type="text">
                  <option [ngValue]="null" disabled>State</option>
                  <option *ngFor="let state of stateList" [ngValue]="state.stateName">
                    {{state.stateName}}</option>
                </select>
                <input *ngIf="stateList.length==0" type="text" placeholder="State"
                  [ngClass]="{ 'is-invalid': submittedEducation && educationFormControl.state.errors }"
                  formControlName="state" class="form-control input-sm">
                <div *ngIf="submittedEducation && educationFormControl.state.errors" class="error-msg">
                  <div class="error-msg" *ngIf="educationFormControl.state.errors.required"> State is required</div>
                </div>
              </div>
            </div>
            <div class="row ">
              <div class="col-sm-6">
                <input type="text" placeholder="city"
                  [ngClass]="{ 'is-invalid': submittedEducation && educationFormControl.city.errors }"
                  formControlName="city" class="form-control input-sm">
                <div *ngIf="submittedEducation && educationFormControl.city.errors" class="error-msg">
                  <div class="error-msg" *ngIf="educationFormControl.city.errors.required"> City is required</div>
                </div>
              </div>
              <div class="col-sm-6">
                <input type="text" maxlength="12" placeholder="Zipcode"
                  [ngClass]="{ 'is-invalid': submittedEducation && educationFormControl.zipcode.errors }"
                  formControlName="zipcode" class="form-control input-sm">
                <div *ngIf="submittedEducation && educationFormControl.zipcode.errors" class="error-msg">
                  <div class="error-msg" *ngIf="educationFormControl.zipcode.errors.required">
                    Zipcode is required
                  </div>
                  <div class="error-msg" *ngIf="educationFormControl.zipcode.errors.minword">
                    {{FORMERROR.ZIPCODE_MIN}}
                  </div>
                  <div class="error-msg" *ngIf="educationFormControl.zipcode.errors.maxword">
                    {{FORMERROR.ZIPCODE_MAX}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="form-group">
            <label for="schoolName" class="col-sm-4 control-label required-field font-light"> Nearby Landmark
            </label>
            <div class="col-sm-7">
              <input type="text" placeholder="Street/Road/Nearby Landmark" formControlName="street"
                class="form-control input-sm"
                [ngClass]="{ 'is-invalid': submittedEducation && educationFormControl.street.errors }">
              <div *ngIf="submittedEducation && educationFormControl.street.errors" class="error-msg">
                <div class="error-msg" *ngIf="educationFormControl.street.errors.required"> Street is required
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="form-group">
            <label for="degree" class="col-sm-4 control-label required-field font-light">Degree</label>
            <div class="col-sm-7">
              <input type="text" class="form-control input-sm" placeholder="Degree" formControlName="degree" trim="blur"
                [ngClass]="{ 'is-invalid': submittedEducation && educationFormControl.degree.errors }">
              <div *ngIf="submittedEducation && educationFormControl.degree.errors" class="error-msg">
                <div class="error-msg" *ngIf="educationFormControl.degree.errors.required"> Degree is required</div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="form-group">
            <label for="speciality" class="col-sm-4 required-field control-label font-light">Speciality</label>
            <div class="col-sm-7">
              <input type="text" class="form-control input-sm" placeholder="Speciality" formControlName="speciality"
                trim="blur" [ngClass]="{ 'is-invalid': submittedEducation && educationFormControl.speciality.errors }">
              <div *ngIf="submittedEducation && educationFormControl.speciality.errors" class="error-msg">
                <div class="error-msg" *ngIf="educationFormControl.speciality.errors.required"> Speciality is required
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="form-group">
            <label class="control-label required-field col-sm-4 font-light">From Date</label>
            <div class="col-sm-7">
              <div class="row">
                <div class="col-sm-6">
                  <ng-select class="gs-pill-select" formControlName="startMonth" placeholder="Month"
                    [clearable]="false" dropdownPosition="auto"
                    [ngClass]="{ 'is-invalid': submittedEducation && educationFormControl.startMonth.errors }"
                    (change)="monthChange('edu')">
                    <ng-option *ngFor="let month of months" [value]="month.name"
                      [disabled]="checkMonth1(month.code,'edu')">{{month.name}}</ng-option>
                  </ng-select>
                  <div *ngIf="submittedEducation && educationFormControl.startMonth.errors" class="error-msg">
                    <div *ngIf="educationFormControl.startMonth.errors.required">
                      From date is required</div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <ng-select class="gs-pill-select" formControlName="startYear" placeholder="Year"
                    [clearable]="false" dropdownPosition="auto"
                    [ngClass]="{ 'is-invalid': submittedEducation && educationFormControl.startYear.errors }"
                    (change)="eduStartYearChange()">
                    <ng-option *ngFor="let year of years" [value]="year">{{year}}</ng-option>
                  </ng-select>
                  <div *ngIf="submittedEducation && educationFormControl.startYear.errors" class="error-msg">
                    <div *ngIf="educationFormControl.startYear.errors.required">
                      Start Year is required</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="form-group" *ngIf="CadidateEducationForm.value.currentlyPursued!=true">
            <label class="control-label required-field col-sm-4 font-light">To Date</label>
            <div class="col-sm-7">
              <div class="row form-group">
                <div class="col-sm-6">
                  <ng-select class="gs-pill-select" formControlName="endMonth" placeholder="Month"
                    [clearable]="false" dropdownPosition="auto"
                    [ngClass]="{ 'is-invalid': submittedEducation && educationFormControl.endMonth.errors }">
                    <ng-option *ngFor="let month of months" [value]="month.name"
                      [disabled]="checkMonth(month.code,'edu')">{{month.name}}</ng-option>
                  </ng-select>
                  <div *ngIf="submittedEducation && educationFormControl.endMonth.errors" class="error-msg">
                    <div *ngIf="educationFormControl.endMonth.errors.required">
                      To date is required</div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <ng-select class="gs-pill-select" formControlName="endYear" placeholder="Year"
                    [clearable]="false" dropdownPosition="auto"
                    [ngClass]="{ 'is-invalid': submittedEducation && educationFormControl.endYear.errors }"
                    (change)="onChangeYear('edu')">
                    <ng-option *ngFor="let year of years" [value]="year"
                      [disabled]="checkYear(year,'edu')">{{year}}</ng-option>
                  </ng-select>
                  <div *ngIf="submittedEducation && educationFormControl.endYear.errors" class="error-msg">
                    <div *ngIf="educationFormControl.endYear.errors.required">
                      End Year is required</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </ng-container>
  </div>
  <div class="modal-footer">
    <div class="col-md-12 padding15 text-right" style="padding: 3px 0;">
      <button class="btn btn-default" (click)="modalRef.hide()">Cancel</button>
      <button class="btn btn-primary btn-danger2  txt-al-ce"
        style="border: 1px solid #8B5CF6; color:#fff;background-color: #8B5CF6;" (click)="EducationFormSave()"> Submit
      </button>
    </div>
  </div>
</ng-template>
<ng-template #certificationModel>
  <div class="modal-header">
    <h4 class="pull-left modal-title"> Certifications </h4>
    <span class="modalai-close" aria-hidden="true" (click)="modalRef.hide()">&times;</span>
  </div>
  <div class="modal-body ">
    <ng-container>
      <form [formGroup]="CadidateCerificationForm" class="form-horizontal padding15">
        <div class="form-horizontal">
          <div class="form-group">
            <label for="certificationName" class="col-sm-4 control-label font-light required-field">Certificate
              Name</label>
            <div class="col-sm-7">
              <input placeholder="Certificate Name" class="form-control input-sm max-hight"
                formControlName="certificationName"
                [ngClass]="{ 'is-invalid': submittedCertification && CerificationControl.certificationName.errors }">
              <div *ngIf="submittedCertification && CerificationControl.certificationName.errors" class="error-msg">
                <div class="error-msg" *ngIf="CerificationControl.certificationName.errors.required">Certificate Name
                  is
                  required
                </div>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="certificateOrganization" class="col-sm-4 control-label font-light required-field">Certifying
              Organization</label>
            <div class="col-sm-7">
              <input type="text" class="form-control input-sm" placeholder="Certifying Organization"
                formControlName="certificateOrganization"
                [ngClass]="{ 'is-invalid': submittedCertification && CerificationControl.certificateOrganization.errors }">
              <div *ngIf="submittedCertification && CerificationControl.certificateOrganization.errors"
                class="error-msg">
                <div class="error-msg" *ngIf="CerificationControl.certificateOrganization.errors.required"> Certifying
                  Organization is required
                </div>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="certificateLicenseNo" class="col-sm-4 control-label font-light required-field">License
              Number</label>
            <div class="col-sm-7">
              <input type="text" class="form-control input-sm" placeholder="License Number"
                formControlName="certificateLicenseNo"
                [ngClass]="{ 'is-invalid': submittedCertification && CerificationControl.certificateLicenseNo.errors }">
              <div *ngIf="submittedCertification && CerificationControl.certificateLicenseNo.errors" class="error-msg">
                <div class="error-msg" *ngIf="CerificationControl.certificateLicenseNo.errors.required"> License
                  Number
                  is required
                </div>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-4 control-label font-light required-field">Issue Date</label>
            <div class="col-sm-7">
              <div class="row">
                <div class="col-sm-6">
                  <ng-select class="gs-pill-select" formControlName="startMonth" placeholder="Month"
                    [clearable]="false" dropdownPosition="auto"
                    [ngClass]="{ 'is-invalid': submittedCertification && CerificationControl.startMonth.errors }"
                    (change)="monthChange('cert')">
                    <ng-option *ngFor="let month of months" [value]="month.name"
                      [disabled]="checkMonth1(month.code,'cert')">{{month.name}}</ng-option>
                  </ng-select>
                  <div *ngIf="submittedCertification && CerificationControl.startMonth.errors" class="error-msg">
                    <div class="error-msg" *ngIf="CerificationControl.startMonth.errors.required"> Month is
                      required
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <ng-select class="gs-pill-select" formControlName="startYear" placeholder="Year"
                    [clearable]="false" dropdownPosition="auto"
                    [ngClass]="{ 'is-invalid': submittedCertification && CerificationControl.startYear.errors }"
                    (change)="certStartYearChange()">
                    <ng-option *ngFor="let year of years" [value]="year">{{year}}</ng-option>
                  </ng-select>
                  <div *ngIf="submittedCertification && CerificationControl.startYear.errors" class="error-msg">
                    <div class="error-msg" *ngIf="CerificationControl.startYear.errors.required"> Year is required
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-4 control-label  font-light required-field">Expiration
              Date</label>
            <div class="col-sm-7">
              <div class="row">
                <div class="col-sm-6">
                  <ng-select class="gs-pill-select" formControlName="endMonth" placeholder="Month"
                    [clearable]="false" dropdownPosition="auto"
                    [ngClass]="{ 'is-invalid': submittedCertification && CerificationControl.endMonth.errors }"
                    (change)="fromMonthChange($event)">
                    <ng-option *ngFor="let month of months" [value]="month.name"
                      [disabled]="checkMonth(month.code,'cert')">{{month.name}}</ng-option>
                  </ng-select>
                  <div *ngIf="submittedCertification && CerificationControl.endMonth.errors" class="error-msg">
                    <div class="error-msg" *ngIf="CerificationControl.endMonth.errors.required"> Month is required
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <ng-select class="gs-pill-select" formControlName="endYear" placeholder="Year"
                    [clearable]="false" dropdownPosition="auto"
                    [ngClass]="{ 'is-invalid': submittedCertification && CerificationControl.endYear.errors }"
                    (change)="onChangeYear('cert')">
                    <ng-option *ngFor="let year of years" [value]="year"
                      [disabled]="checkYear(year,'cert')">{{year}}</ng-option>
                  </ng-select>
                  <div *ngIf="submittedCertification && CerificationControl.endYear.errors" class="error-msg">
                    <div class="error-msg" *ngIf="CerificationControl.endYear.errors.required"> Year is required
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </ng-container>
  </div>
  <div class="modal-footer">
    <div class="col-md-12 padding15 text-right" style="padding: 3px 0;">
      <button class="btn btn-default" (click)="modalRef.hide()">Cancel</button>
      <button class="btn btn-primary btn-danger2  txt-al-ce"
        style="border: 1px solid #8B5CF6; color:#fff;background-color: #8B5CF6;" (click)="certificateFormsave()">
        Submit
      </button>
    </div>
  </div>
</ng-template>
<ng-template #businessEmail>
  <div class="hpanel">
    <div class="panel-heading">
      <div class="row panel-tools" style="padding-right: 20px;">
        <button type="button" class="close" aria-label="Close" (click)="closeBusiness()">
          <span style="font-size: 26px;font-weight:400;" aria-hidden="true">&times;</span>
        </button>
      </div>
      <label class="control-label padding-top-0 margin-bottom-5 margin-top-5 "
        style="margin-left: 8px !important;">Authenticate Business Email </label>
    </div>
    <div class="panel-body">
      <form [formGroup]="domainForm">
        <div class="app-form">
          <div class="form-group row">
            <div class="row alrt-dngr">
              <div class="alert alert-danger addd-dngr" role="alert" style="margin-left:23px; margin-right:23px;">
                Please, note that after you authenticate your new business email address, your previous login
                credentials will be changed for the new business email.
              </div>
            </div>
            <div class="col-sm-12" style="display: flex; padding: 10px 18px; align-items: center;column-gap: 9px;">
              <div>
                <label>Previous Business Email:</label>
              </div>
              <div>{{previousMailId}}</div>
            </div>
            <div class="col-sm-12" *ngIf="!checkotpEmailSent" style="padding-bottom: 7px;">
              <label for="swapEmail" class="control-label required-field font-bold">New Business Email
                Address</label>
              <input class="form-control input-sm" type="email" formControlName="businessemail"
                (input)="checkMailExists($event.target.value)">
              <div *ngIf="domainControl.businessemail.errors.emailExists" style="color: #c3002f">
                That email is taken already. Please, enter a different one.
              </div>
              <div
                *ngIf="domainControl.businessemail.errors.invalid && (domainControl.businessemail.dirty || domainControl.businessemail.touched)"
                style="color: #c3002f">
                email is required
              </div>
              <div *ngIf="emailvalid!=null" style="color: #c3002f">
                {{emailvalid}}
              </div>
            </div>
            <div class="col-sm-12" style="display:flex; column-gap: 13px;
            align-items: center;" *ngIf="checkotpEmailSent">
              <label for="">New Business Email:</label>
              {{newPrimaryEmail}}
            </div>
            <div class="row alrt-dngr">
              <div *ngIf="checkotpEmailSent" class="alert alert-info addd-dngr" role="alert"
                style="margin-left:23px; margin-right:23px;">
                An authentication code has been sent to your new business email. Please, enter it below. The code is
                valid only for 10 minutes.
              </div>
            </div>
            <div class="col-sm-12" *ngIf="checkotpEmailSent">
              <label for="domainValidationOtp" class="control-label required-field font-bold">Enter OTP</label>
              <input class="form-control input-sm" formControlName="domainValidationOtp" type="text" trim="blur"
                maxlength="6" (change)="updateOtp()">
            </div>
            <span *ngIf=" checkotpEmailSent && domainControl.domainValidationOtp.errors?.wrongOtp"
              style="color: #c3002f; margin-left: 16px;">
              Incorrect OTP. Enter the right one.
            </span>
            <span
              *ngIf=" checkotpEmailSent && !domainControl.domainValidationOtp.errors?.wrongOtp && domainForm.value.domainValidationOtp?.length==0"
              style="color: #c3002f; margin-left: 16px;">
              Please Enter the Otp.
            </span>
            <div class="row" *ngIf="checkotpEmailSent">
              <div class="pull-left" style="margin-left: 28px;">
                <div>
                  <a role="button" *ngIf="!resenOtp  && checkotpEmailSent " (click)="requestAnotherOTP()">Request
                    another code</a>
                </div>
                <div *ngIf="resenOtp" style="color: #c3002f">
                  Another code has been sent to your business email address.
                  Please enter the code.
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="custom-panel-footer">
      <div class="panel-footer">
        <div class="shifu" style="margin-left: 42rem;">
          <button style="margin-right:12px;" *ngIf="!checkotpEmailSent" class="btn btn-default"
            (click)="closeValidator()">Go Back</button>
          <button class="btn  btn-primary" [disabled]="!domainForm.value.businessemail" *ngIf="!checkotpEmailSent"
            type="submit" (click)="proceedAfterValidation()">Proceed</button>
          <button class="btn  btn-primary" style="margin-left: 50px;" *ngIf="checkotpEmailSent" type="submit"
            (click)="validateOtp()">Validate OTP</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
